import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

type Inputs = { callLogId?: number | null; callSid?: string | null };
export const fetchCallLog = async ({ callLogId, callSid }: Inputs) => {
  const response = await queryExecute({
    variables: {
      id: callLogId,
      callSid,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query callLog($id: Float, $callSid: String) {
        callLog(id: $id, callSid: $callSid) {
          id
          direction
          callerId
          rideId
          groceryId
          gourmetId
          operatorId
          fromPhoneNumber
          toPhoneNumber
          resolvedPhoneNumber
          callFlow
          isOnHold
          callSid
          purpose
          notes
          hasRecording
          isRegistrationCall
          isNoMembership
          callType
          extension
          transferReason
          abTestGroups {
            groupType
            groupLabel
          }
          registrationTransferNotes {
            title
            callNotes
            fromDepartment
            alreadyDiscussed
            notesForOperator
          }
        }
      }
    `),
  });

  return response.data.callLog;
};
